import Styles from './EnrolMetrics.module.scss';
import { useState, useContext, useEffect } from 'react';

import { useNavigate, ViewContext, useAPI, AuthContext, useCan } from 'components/lib';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

import FeatherIcon from 'feather-icons-react';
import * as FeatherIconsList from 'feather-icons-react';

import { Pagination, Checkbox, Tooltip } from '@mui/material';
import axios from 'axios';

export function EnrolMetrics(props) {
    const viewContext = useContext(ViewContext);
    const authContext = useContext(AuthContext);
    const permission = useCan('user.metrics.enroll.view')
    const permissionAdmin = useCan('user.admin.metrics.enroll.view')
    const navigate = useNavigate();

    const { data, loading } = useAPI(`/api/metrics?limit=10&pageNumber=1`)

    const [availableMetrics, setAvailableMetrics] = useState([]);
    const [showLoading, setShowLoading] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const [selectedMetrics, setSelectedMetrics] = useState([]);

    useEffect(() => {
        if (data?.metrics?.length) {
            setAvailableMetrics(data?.metrics)
        }
    }, [data])


    function handleMetricsSelection(metricId) {
        const selectMetricsTemp = [...selectedMetrics]
        if (selectedMetrics.includes(metricId)) {
            const newSelectedMetricsTemp = selectMetricsTemp.filter(item => item !== metricId);
            setSelectedMetrics(newSelectedMetricsTemp)
        } else {
            selectMetricsTemp.push(metricId);
            setSelectedMetrics(selectMetricsTemp)
        }
    }

    const handlePageChange = (event, pageNumber) => {
        const options = {
            method: "GET",
            url: `/api/metrics?limit=10&pageNumber=${pageNumber}`,
            headers: {
                "accept": "application/json",
            },
        };
        axios
            .request(options)
            .then(function (response) {
                setAvailableMetrics(response?.data?.data?.metrics)
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    };

    const handleEnroll = () => {
        setShowLoading(true)
        const options = {
            method: "POST",
            url: `/api/user/metrics/enroll`,
            headers: {
                "accept": "application/json",
            },
            data: { ids: selectedMetrics },
        };
        axios
            .request(options)
            .then(function () {
                viewContext.notification.show(props.t('QualityQuotient.EnrolMetrics.notification.success'), "success")
                setTimeout(() => {
                    navigate('/user/metrics')
                }, 1500)
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    }

    return (
        <>
            {loading && <LoadingBackdrop isOpen={loading} />}
            {showLoading && <LoadingBackdrop isOpen={true} />}
            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                <div id='headerContainer' className={Styles.headerContainer}>
                    <BreadCrumbs
                        onClickPaths={[
                            '/user/metrics',
                            ''
                        ]}
                        crumbs={props.t('QualityQuotient.EnrolMetrics.breadcrumbs', { returnObjects: true })}
                    />
                    <span style={{ display: "flex" }}>
                        <AivagamButton
                            type="back"
                            id="clearSelection"
                            classStyles={{
                                textDecoration: "underline"
                            }}
                            buttonText={props.t('QualityQuotient.EnrolMetrics.button.clear.title')}
                            disabled={selectedMetrics?.length === 0}
                            onClick={() => setSelectedMetrics([])}
                        />
                        <AivagamButton
                            id="enrollButton"
                            type='action'
                            disabled={selectedMetrics?.length === 0 || selectedMetrics?.length > 5}
                            buttonText={
                                <>
                                    {selectedMetrics.length === 0 ? (
                                        <FeatherIcon
                                            color='black'
                                            icon='plus'
                                            size="1.1em"
                                        />
                                    ) : (
                                        <span style={{
                                            marginRight: "0.25em",
                                            backgroundColor: "black",
                                            color: "white",
                                            width: "1.1em",
                                            borderRadius: "4px"
                                        }}>
                                            {selectedMetrics.length}
                                        </span>
                                    )}
                                    {props.t('QualityQuotient.EnrolMetrics.button.enroll.title')}
                                </>
                            }
                            classStyles={{ borderRadius: "8px", fontWeight: "700" }}
                            tooltipText={
                                selectedMetrics?.length ?
                                    selectedMetrics?.length > 5 ?
                                        props.t('QualityQuotient.EnrolMetrics.button.enroll.tooltipMax')
                                        : ""
                                    : props.t('QualityQuotient.EnrolMetrics.button.enroll.tooltipMin')
                            }
                            icon
                            onClick={handleEnroll}
                        />
                    </span>
                </div>
                {availableMetrics?.length !== 0 &&
                    <div id='paginationContainer' className={Styles.paginationContainer}>
                        <span>
                            {
                                props.t('QualityQuotient.EnrolMetrics.total',
                                    { current: availableMetrics?.length, total: data?.total })
                            }
                        </span>
                        {data?.totalPages > 0 &&
                            <Pagination
                                count={data?.totalPages}
                                color="primary"
                                // variant='outlined'
                                onChange={handlePageChange}
                                size="small"
                                sx={{
                                    maxWidth: "50%",
                                    // marginLeft: "auto",
                                    width: "fit-content",
                                    marginTop: "0.5em",
                                }}
                            />
                        }
                    </div>
                }
                <div id='metricsList' className={Styles.metricsList}>
                    {availableMetrics?.map((metric, index) => {
                        if (!(permission && permissionAdmin) && (metric.assessments === 0 || metric.status === "closed")) { 
                            return null;
                        }
                        const IconComponent = FeatherIconsList[metric.icon]
                        return (
                            <div
                                key={metric.id}
                                className={Styles.metricHolder}
                                onClick={() => {
                                    if (!metric.assessments || ["draft"].includes(metric.status)) {
                                        viewContext.notification.show(props.t('QualityQuotient.EnrolMetrics.notification.warn'), "warning", "true")
                                    } else {
                                        handleMetricsSelection(metric.id)
                                    }
                                }}
                            >
                                <Checkbox checked={selectedMetrics?.includes(metric.id)} />
                                <div
                                    id='metricCard'
                                    className={Styles.metricCard}
                                    style={{
                                        backgroundColor: selectedMetrics?.includes(metric.id) ? 'lightgray' : ''
                                    }}
                                >
                                    <IconComponent size="1em" />
                                    <span className={Styles.metricNameContainer}>
                                        <span className={Styles.metricName}>
                                            {metric.name}
                                        </span>
                                        {
                                            ["closed", "draft"].includes(metric.status) &&
                                            <span className={Styles.metricStatus}>
                                                <FeatherIcon
                                                    color='black'
                                                    icon='circle'
                                                    size="0.6em"
                                                />
                                                {metric.status.toUpperCase()}
                                            </span>
                                        }
                                    </span>
                                    <span className={Styles.metricDetail}>
                                        Assessments: {metric.assessments}
                                    </span>
                                    {permission && permissionAdmin && 
                                        <Tooltip arrow placement="right" title={props.t('QualityQuotient.EnrolMetrics.tooltip')}>
                                            <button
                                                className={Styles.iconButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/metrics/${metric.id}/edit`)
                                                }}
                                            >
                                                <FeatherIcon
                                                    color='black'
                                                    icon='settings'
                                                    size="1em"
                                                />
                                            </button>
                                        </Tooltip>
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
                {availableMetrics?.length === 0 &&
                    <div id='noMetrics' className={Styles.noMetrics}>
                        {props.t('QualityQuotient.EnrolMetrics.message')}
                        {permission && permissionAdmin && 
                            <>
                                <br />
                                {props.t('QualityQuotient.EnrolMetrics.admin')}
                                <AivagamButton
                                    id="saveForm"
                                    buttonText={
                                        <>
                                            <FeatherIcon
                                                color='white'
                                                icon='plus'
                                            />
                                            {props.t('QualityQuotient.UserMetrics.button.add')}
                                        </>
                                    }
                                    icon
                                    onClick={() => {
                                        navigate('/metrics/create')
                                    }}
                                />
                            </>
                        }
                    </div>
                }
            </div >
        </>
    )
}